/**
 * 3 Tinkers Product Page JavaScript
 * Handles:
 * - Ring style variant selection
 * - Size selection
 * - Engraving validation & preview
 * - Gallery interactions
 * - Sticky bar visibility
 * - Add to cart functionality
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initGallery();
    initVariantSelection();
    initSizeSelection();
    initFontDropdown();
    initEngraving();
    initAccordion();
    initStickyBar();
    initAddToCart();
    trackRecentlyViewed();
    
    // Also track when widget initializes (to get style info)
    setTimeout(() => trackRecentlyViewed(), 1000);
    
    // Update when style changes
    document.addEventListener('ramboRingStyleChanged', () => {
      setTimeout(() => trackRecentlyViewed(), 500);
    });
  }

  /**
   * TRACK RECENTLY VIEWED PRODUCTS
   */
  function trackRecentlyViewed() {
    const STORAGE_KEY = 'recently_viewed_products';
    const MAX_PRODUCTS = 8;
    
    // Get product data from the page
    const productData = window.productData || {};
    if (!productData.id) return;
    
    try {
      // Get existing products
      let products = [];
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        products = JSON.parse(stored);
      }
      
      // Remove this product if it already exists
      products = products.filter(p => p.id !== productData.id);
      
      // Get the main product image
      const mainImage = document.querySelector('.tp-main-image');
      const imageUrl = mainImage ? mainImage.src : (productData.featured_image || '');
      
      // Get compare at price if available
      const compareAtPriceEl = document.querySelector('.tp-compare-price');
      const compareAtPrice = compareAtPriceEl ? compareAtPriceEl.textContent.trim() : null;
      
      // Get selected style info from widget state (wait for it to be available)
      const widgetState = window.ramboRingWidgetState || {};
      const styleIndex = typeof widgetState.selectedStyleIndex === 'number' && widgetState.selectedStyleIndex >= 0 
        ? widgetState.selectedStyleIndex 
        : null;
      const styleCode = widgetState.selectedStyleCode || null;
      const styleLabel = widgetState.selectedStyleLabel || null;
      
      // Also try to get from active swatch if widget state doesn't have it yet
      let finalStyleIndex = styleIndex;
      let finalStyleCode = styleCode;
      let finalStyleLabel = styleLabel;
      
      if (!finalStyleIndex && !finalStyleCode) {
        const activeSwatch = document.querySelector('.ring-style-picker__swatch.active, .ring-style-picker__swatch--active');
        if (activeSwatch) {
          const swatchIndex = activeSwatch.getAttribute('data-style-index');
          if (swatchIndex !== null) finalStyleIndex = parseInt(swatchIndex, 10);
          finalStyleCode = activeSwatch.getAttribute('data-style-code') || finalStyleCode;
          finalStyleLabel = activeSwatch.getAttribute('data-style-label') || finalStyleLabel;
        }
      }
      
      console.log('[TrackRecentlyViewed] Saving product', productData.id, 'with style:', finalStyleCode || 'index ' + finalStyleIndex);
      
      // Add current product to the beginning
      products.unshift({
        id: productData.id,
        title: productData.title || document.querySelector('.tp-product-title')?.textContent || 'Product',
        url: window.location.pathname,
        image: imageUrl,
        price: productData.price_formatted || document.querySelector('.tp-current-price')?.textContent || '',
        compare_at_price: compareAtPrice,
        styleIndex: finalStyleIndex,
        styleCode: finalStyleCode,
        styleLabel: finalStyleLabel
      });
      
      // Keep only the most recent products
      products = products.slice(0, MAX_PRODUCTS);
      
      // Save back to localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (e) {
      console.warn('Could not save recently viewed product:', e);
    }
  }

  /**
   * CUSTOM FONT DROPDOWN
   */
  function initFontDropdown() {
    const dropdown = document.getElementById('font-dropdown');
    const trigger = document.getElementById('font-trigger');
    const options = document.getElementById('font-options');
    const selected = document.getElementById('font-selected');
    const hiddenInput = document.getElementById('engraving-font-input');
    const previewText = document.querySelector('.tp-preview-text');

    if (!dropdown || !trigger) return;

    // Toggle dropdown
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      dropdown.classList.toggle('open');
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    });

    // Option selection
    const optionElements = options.querySelectorAll('.tp-select-option');
    optionElements.forEach(option => {
      option.addEventListener('click', function() {
        const value = this.dataset.value;
        const fontFamily = this.dataset.font;

        // Update hidden input
        if (hiddenInput) {
          hiddenInput.value = value;
        }

        // Update trigger display
        selected.textContent = value;
        selected.style.fontFamily = fontFamily;

        // Update active state
        optionElements.forEach(o => o.classList.remove('active'));
        this.classList.add('active');

        // Update preview
        if (previewText) {
          previewText.style.fontFamily = fontFamily;
        }

        // Close dropdown
        dropdown.classList.remove('open');
        
        // Update sticky bar
        updateAddToCartState();
        
        // Save to localStorage (call widget's save function if available)
        console.log('[tp-product] Font selected:', value);
        if (typeof window.saveRamboSelections === 'function') {
          setTimeout(() => {
            console.log('[tp-product] Calling saveRamboSelections for font...');
            window.saveRamboSelections();
          }, 150);
        } else {
          console.warn('[tp-product] saveRamboSelections not available yet');
        }
      });
    });

    // PRE-FILL FROM URL PARAMETER
    const urlParams = new URLSearchParams(window.location.search);
    const fontFromUrl = urlParams.get('engraving_font');
    if (fontFromUrl && optionElements.length > 0) {
      // Find matching option
      optionElements.forEach(option => {
        if (option.dataset.value === fontFromUrl) {
          option.click(); // Trigger the click to set everything
        }
      });
    }
  }

  /**
   * GALLERY INTERACTIONS
   */
  function initGallery() {
    const gallery = document.querySelector('.tp-product-gallery');
    if (!gallery) return;

    const thumbnails = gallery.querySelectorAll('.tp-thumbnail-btn');
    const mainImage = gallery.querySelector('.tp-main-image');
    const scrollUpBtn = gallery.querySelector('[data-scroll="up"]');
    const scrollDownBtn = gallery.querySelector('[data-scroll="down"]');
    const thumbnailsContainer = gallery.querySelector('.tp-thumbnails-container');

    // Thumbnail click handler
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        const imageSrc = this.dataset.fullImage;
        const imageAlt = this.dataset.alt || '';

        // Update active state
        thumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        // Update main image
        if (mainImage && imageSrc) {
          mainImage.src = imageSrc;
          mainImage.alt = imageAlt;
        }
      });
    });

    // Scroll buttons
    if (scrollUpBtn && thumbnailsContainer) {
      scrollUpBtn.addEventListener('click', () => {
        thumbnailsContainer.scrollBy({ top: -200, behavior: 'smooth' });
      });
    }

    if (scrollDownBtn && thumbnailsContainer) {
      scrollDownBtn.addEventListener('click', () => {
        thumbnailsContainer.scrollBy({ top: 200, behavior: 'smooth' });
      });
    }
  }

  /**
   * VARIANT (STYLE) SELECTION
   */
  function initVariantSelection() {
    const styleSwatches = document.querySelectorAll('.tp-style-swatch');
    const variantIdInput = document.querySelector('input[name="id"]');
    const selectedStyleSpan = document.querySelector('.tp-selected-style');
    const mainImage = document.querySelector('.tp-main-image');

    if (!styleSwatches.length) return;

    styleSwatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        const styleName = this.dataset.styleName;
        const variantImage = this.dataset.variantImage;
        const variantPrice = this.dataset.price;

        // Update hidden input
        if (variantIdInput) {
          variantIdInput.value = variantId;
        }

        // Update UI
        styleSwatches.forEach(s => s.classList.remove('active'));
        this.classList.add('active');

        // Update style name display
        if (selectedStyleSpan) {
          selectedStyleSpan.textContent = styleName;
        }

        // Update main image
        if (mainImage && variantImage) {
          mainImage.src = variantImage;
        }

        // Update price display
        if (variantPrice) {
          updatePriceDisplay(variantPrice);
        }

        updateAddToCartState();
      });
    });
  }

  /**
   * SIZE SELECTION
   */
  function initSizeSelection() {
    const sizeOptions = document.querySelectorAll('.tp-size-option');
    const sizeInput = document.querySelector('.tp-size-input');

    if (!sizeOptions.length) return;

    sizeOptions.forEach(option => {
      option.addEventListener('click', function() {
        if (this.classList.contains('disabled')) return;

        const size = this.dataset.size;
        const container = this.closest('.tp-size-options');
        const siblingOptions = container ? container.querySelectorAll('.tp-size-option') : sizeOptions;

        // Update UI - only toggle siblings in the same container
        siblingOptions.forEach(o => o.classList.remove('active'));
        this.classList.add('active');

        // Update hidden input
        if (sizeInput) {
          sizeInput.value = size;
        }

        // Find and update the correct variant based on selected options
        updateVariantFromOptions();
        updateAddToCartState();
      });
    });
  }

  /**
   * UPDATE VARIANT FROM SELECTED OPTIONS
   */
  function updateVariantFromOptions() {
    // Get the product data from the page
    const productForm = document.querySelector('.tp-product-form');
    if (!productForm) return;

    // Get selected style (if any)
    const selectedStyleSwatch = document.querySelector('.tp-style-swatch.active');
    
    // Get selected size (if any)
    const selectedSizeOption = document.querySelector('.tp-size-option.active');
    
    // If we have style swatches, they control the variant directly
    if (selectedStyleSwatch) {
      const variantId = selectedStyleSwatch.dataset.variantId;
      const variantIdInput = document.querySelector('input[name="id"]');
      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }
    }
  }

  /**
   * ENGRAVING FUNCTIONALITY
   */
  function initEngraving() {
    const engravingSection = document.querySelector('.tp-engraving-section');
    if (!engravingSection) return;

    const textInput = engravingSection.querySelector('.tp-engraving-input');
    const charCount = engravingSection.querySelector('.tp-char-count');
    const charCounter = engravingSection.querySelector('.tp-char-counter');
    const previewText = engravingSection.querySelector('.tp-preview-text');
    const previewPlaceholder = engravingSection.querySelector('.tp-preview-placeholder');
    const maxLength = parseInt(textInput?.getAttribute('maxlength') || 37);

    if (!textInput) return;

    // Update preview function
    function updatePreview() {
      const text = textInput.value.trim();

      if (text) {
        if (previewText) {
          previewText.textContent = text;
          previewText.style.display = 'flex';
          
          // Auto-size text to fit
          autoSizePreviewText(previewText, text);
        }
        if (previewPlaceholder) {
          previewPlaceholder.style.display = 'none';
        }
      } else {
        if (previewText) {
          previewText.style.display = 'none';
        }
        if (previewPlaceholder) {
          previewPlaceholder.style.display = 'flex';
        }
      }
    }

    // Auto-size preview text to fit on one line
    function autoSizePreviewText(element, text) {
      if (!text || text.length === 0) return;
      
      // Calculate font size based on character count
      const charCount = text.length;
      let fontSize;
      
      if (charCount <= 8) {
        fontSize = 42;
      } else if (charCount <= 12) {
        fontSize = 38;
      } else if (charCount <= 16) {
        fontSize = 34;
      } else if (charCount <= 20) {
        fontSize = 30;
      } else if (charCount <= 25) {
        fontSize = 26;
      } else if (charCount <= 30) {
        fontSize = 22;
      } else if (charCount <= 35) {
        fontSize = 19;
      } else {
        fontSize = 16;
      }
      
      element.style.fontSize = fontSize + 'px';
    }

    // Update character counter
    function updateCharCounter() {
      const length = textInput.value.length;
      
      if (charCount) {
        charCount.textContent = length;
      }

      if (charCounter) {
        if (length >= maxLength) {
          charCounter.classList.add('warning');
        } else {
          charCounter.classList.remove('warning');
        }
      }
    }

    // Event listeners
    textInput.addEventListener('input', function() {
      updateCharCounter();
      updatePreview();
      updateAddToCartState();
      
      // Save to localStorage (call widget's save function if available)
      if (typeof window.saveRamboSelections === 'function') {
        clearTimeout(textInput._saveTimeout);
        textInput._saveTimeout = setTimeout(() => {
          console.log('[tp-product] Saving engraving text...');
          window.saveRamboSelections();
        }, 300);
      } else {
        console.warn('[tp-product] saveRamboSelections not available for text input');
      }
    });
    
    // Also save on blur
    textInput.addEventListener('blur', function() {
      if (typeof window.saveRamboSelections === 'function') {
        console.log('[tp-product] Saving engraving text on blur...');
        window.saveRamboSelections();
      }
    });

    // PRE-FILL FROM URL PARAMETER
    const urlParams = new URLSearchParams(window.location.search);
    const textFromUrl = urlParams.get('engraving_text');
    if (textFromUrl) {
      textInput.value = textFromUrl;
    }

    // Initial state
    updateCharCounter();
    updatePreview();
  }

  /**
   * ACCORDION FUNCTIONALITY
   */
  function initAccordion() {
    const accordionItems = document.querySelectorAll('.tp-accordion-item');

    accordionItems.forEach(item => {
      const header = item.querySelector('.tp-accordion-header');
      
      if (header) {
        header.addEventListener('click', function() {
          item.classList.toggle('open');
        });
      }
    });
  }

  /**
   * STICKY BAR VISIBILITY
   */
  function initStickyBar() {
    const stickyBar = document.querySelector('.tp-sticky-bar');
    const addToCartBtn = document.querySelector('.tp-add-to-cart-btn');

    if (!stickyBar || !addToCartBtn) return;

    // Use scroll-based approach (more reliable than IntersectionObserver)
    let lastScrollTop = 0;
    const scrollThreshold = 300; // Show after scrolling 300px
    const productSection = document.querySelector('.tp-product-section, .product-page, main');

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const productRect = productSection ? productSection.getBoundingClientRect() : null;

      // Show sticky bar when scrolled past threshold and scrolling down
      if (scrollTop > scrollThreshold && scrollTop > lastScrollTop) {
        stickyBar.classList.add('visible');
      } else if (scrollTop < scrollThreshold || scrollTop < lastScrollTop) {
        stickyBar.classList.remove('visible');
      }

      // Hide when reaching footer or bottom of product section
      if (productRect && productRect.bottom < 0) {
        stickyBar.classList.remove('visible');
      }

      lastScrollTop = scrollTop;
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // NOTE: Sticky bar button click is handled elsewhere (rambo-ring-widget.js or below)
    // Removed duplicate handler that was causing double add-to-cart
  }

  /**
   * UPDATE ADD TO CART BUTTON STATE
   */
  function updateAddToCartState() {
    const addToCartBtn = document.querySelector('.tp-add-to-cart-btn');
    const stickyBarBtn = document.getElementById('stickyBarBtn');
    const stickyBarSize = document.getElementById('stickyBarSize');
    const stickyBarEngraving = document.getElementById('stickyBarEngraving');
    
    if (!addToCartBtn) return;

    // Check if size is selected (if size options exist)
    const sizeOptionsExist = document.querySelectorAll('.tp-size-option').length > 0;
    const selectedSize = document.querySelector('.tp-size-option.active');
    const sizeSelected = !sizeOptionsExist || selectedSize;
    
    // Check if engraving is required and filled
    const engravingInput = document.querySelector('.tp-engraving-input');
    const isEngravingRequired = engravingInput && engravingInput.hasAttribute('required');
    const hasEngraving = engravingInput ? engravingInput.value.trim().length > 0 : true;

    // Enable/disable buttons
    const canAddToCart = sizeSelected && (!isEngravingRequired || hasEngraving);

    addToCartBtn.disabled = !canAddToCart;
    
    if (stickyBarBtn) {
      stickyBarBtn.disabled = !canAddToCart;
    }
    
    // Update sticky bar size display
    if (stickyBarSize) {
      if (selectedSize) {
        stickyBarSize.textContent = selectedSize.textContent.trim();
      } else {
        stickyBarSize.textContent = '';
      }
    }
    
    // Update sticky bar font display
    const stickyBarFont = document.getElementById('stickyBarFont');
    const fontSelected = document.getElementById('font-selected');
    if (stickyBarFont && fontSelected) {
      const fontName = fontSelected.textContent.trim();
      if (fontName) {
        stickyBarFont.textContent = fontName;
        stickyBarFont.style.fontFamily = fontSelected.style.fontFamily;
      }
    }
    
    // Update sticky bar engraving display
    if (stickyBarEngraving && engravingInput) {
      const engravingText = engravingInput.value.trim();
      stickyBarEngraving.textContent = engravingText;
      
      // Apply the selected font to the engraving text
      if (fontSelected && fontSelected.style.fontFamily) {
        stickyBarEngraving.style.fontFamily = fontSelected.style.fontFamily;
      }
    }
  }

  /**
   * UPDATE PRICE DISPLAY
   */
  function updatePriceDisplay(price) {
    const priceElement = document.querySelector('.tp-price-current');
    const addToCartText = document.querySelector('.tp-add-to-cart-text');
    
    if (priceElement && price) {
      priceElement.textContent = price;
    }
    
    if (addToCartText && price) {
      addToCartText.textContent = 'Add to Cart - ' + price;
    }
  }

  /**
   * ADD TO CART FUNCTIONALITY
   */
  function initAddToCart() {
    const form = document.querySelector('.tp-product-form');
    if (!form) return;

    // Handle both form submit AND button click
    const handleAddToCart = function(e) {
      e.preventDefault();
      e.stopPropagation();

      const addToCartBtn = form.querySelector('.tp-add-to-cart-btn');
      const addToCartText = addToCartBtn.querySelector('.tp-add-to-cart-text');
      const originalText = addToCartText ? addToCartText.textContent : 'Add to Cart';

      // Disable button and show loading
      addToCartBtn.disabled = true;
      if (addToCartText) {
        addToCartText.textContent = 'Adding...';
      }

      // Gather form data
      const formData = new FormData(form);

      // Submit to Shopify cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Success
        if (addToCartText) {
          addToCartText.textContent = 'Added!';
        }

        // Update cart count
        updateCartCount();

        // Dispatch cart refresh event and open drawer
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        // Open cart drawer after short delay
        setTimeout(() => {
          const cartDrawer = document.getElementById('cart-drawer');
          if (cartDrawer) {
            // Try the show method
            if (typeof cartDrawer.show === 'function') {
              cartDrawer.show();
            } else {
              // Set open attribute
              cartDrawer.setAttribute('open', '');
            }
          } else {
            // Fallback: click the cart button to open drawer
            const cartBtn = document.querySelector('[aria-controls="cart-drawer"]');
            if (cartBtn) cartBtn.click();
          }
        }, 500);

        // Reset button after delay
        setTimeout(() => {
          addToCartBtn.disabled = false;
          if (addToCartText) {
            addToCartText.textContent = originalText;
          }
        }, 1500);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        if (addToCartText) {
          addToCartText.textContent = 'Error - Try Again';
        }

        setTimeout(() => {
          addToCartBtn.disabled = false;
          if (addToCartText) {
            addToCartText.textContent = originalText;
          }
        }, 2000);
      });
    };

    // Attach to form submit
    form.addEventListener('submit', handleAddToCart);
    
    // ALSO attach directly to the add to cart button click
    const mainAddToCartBtn = form.querySelector('.tp-add-to-cart-btn');
    // SKIP if RAMBO_RING_CONFIG exists - rambo-ring-widget.js handles add-to-cart
    if (window.RAMBO_RING_CONFIG) {
      console.log('tp-product.js: Skipping add-to-cart handlers (RAMBO handles it)');
      return;
    }

    if (mainAddToCartBtn) {
      mainAddToCartBtn.addEventListener('click', function(e) {
        // Prevent double-firing with form submit
        if (!form.hasAttribute('data-submitting')) {
          form.setAttribute('data-submitting', 'true');
          handleAddToCart(e);
          setTimeout(() => form.removeAttribute('data-submitting'), 100);
        }
      });
    }

    // Also handle sticky bar button
    const stickyBarBtn = document.querySelector('.tp-sticky-bar-btn');
    if (stickyBarBtn) {
      stickyBarBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!form.hasAttribute('data-submitting')) {
          form.setAttribute('data-submitting', 'true');
          handleAddToCart(e);
          setTimeout(() => form.removeAttribute('data-submitting'), 100);
        }
      });
    }
  }

  /**
   * UPDATE CART COUNT
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
        
        // Also update any cart bubble/badge in header
        const cartBubble = document.querySelector('.cart-count, .header__cart-count, [data-cart-item-count]');
        if (cartBubble) {
          cartBubble.textContent = cart.item_count;
        }
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }

  // Expose update function globally for sticky bar
  window.updateStickyBar = updateAddToCartState;

})();

